export function Random() {
    return (
        <span>
            Misc
        </span>
    )
}